import './status.css'
import { Circle } from 'lucide-react';

const StatusBadge = ({ status }) => {
  return (
    <>
      {status && status !== "" &&
        <div className={`status-badge ${status}`}>
          <Circle className={status} size={"0.8rem"} />
          <div>{status.replace("-", " ")}</div>
        </div>
      }
    </>
  );
}

export default StatusBadge;